"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var component_1 = require("./component");
exports.styleSingleton = component_1.styleSingleton;
var singleton_1 = require("./singleton");
exports.stylesheetSingleton = singleton_1.stylesheetSingleton;
var hook_1 = require("./hook");
exports.styleHookSingleton = hook_1.styleHookSingleton;



//////////////////
// WEBPACK FOOTER
// ./~/react-style-singleton/dist/es5/index.js
// module id = 139
// module chunks = 0